export const primaryColor = '#0F9F67';
export const encountersToUnlock = 5;
